module.exports = __webpack_public_path__ + "img/dish.b74be99e.svg";